<!--  -->
<template>
  <div class="sub-nav">
    <ul class="titleList">
      <li
        :class="{ active: selected == index }"
        v-for="(item, index) in subNavList"
        @click="changeTab(index)"
        :key="index"
      >
        <p class="name">{{ item.name }}</p>
        <span></span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  components: {},
  data() {
    return {
      selected: 0,
    };
  },
  props: {
    subNavList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
  },
  watch: {},
  methods: {
    changeTab(index) {
      if (this.lastTime) {
        if (Date.now() - this.lastTime < 500) return console.log('点击过快');
      }
      this.selected = index;
      this.lastTime = Date.now();
      this.$emit('sendCatalog', { index });
      // eslint-disable-next-line
      gio('evar.set', 'courseList_evar', this.subNavList[index].name);
      return true;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.titleList {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 80px;
  padding: 0 0 0 30px;
  overflow: auto;
  // background: #fff;
  -webkit-overflow-scrolling: touch;

  > li {
    position: relative;
    flex: 0 0 auto;
    box-sizing: border-box;
    height: 80px;
    margin: 0 34px 0 0;
    // border-bottom: 3px solid #fff;
    -webkit-box-flex: 1;
    .name {
      padding: 10px 0 4px 0;
      color: $fontColor;
      font-size: 32px;
      // font-weight: bold;
      line-height: 44px;
    }

    img {
      position: absolute;
      top: 0;
      right: 30px;
      width: 32px;
      height: 32px;
    }

    > span {
      display: none;
      width: 38px;
      height: 13px;
      background: url(../../../assets/img/loginImg/activeType.png) no-repeat
        center;
      background-size: 100% 100%;
      // border-radius: 0.02px;
    }
  }
  > li.active {
    height: 55px;
    height: 80px;
    font-size: 32px;
    p {
      color: #ff6c02;
      font-weight: bold;
      font-size: 36px;
    }

    > span {
      display: block;
      margin: 0 auto;
    }
  }
}
.titleList::-webkit-scrollbar {
  display: none;
}
</style>
